import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { HeadProvider } from 'react-head';
import { Provider } from 'react-redux';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { ConfigProvider } from 'antd';
import ruRU from 'antd/lib/locale/ru_RU';

import {
  setLocale,
  loadTranslations,
  syncTranslationWithStore,
} from 'react-redux-i18n';
import translations from './i18n/translations';

import configureStore from './configureStore';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import App from './App';
import {
  routeChange as actionRouteChange,
  trackProgkids,
  trackYandexParams,
  initCarrotQuest,
} from './actions/utils';
import {
  disconnectSockets,
  isGuiRoute,
} from './actions/socket';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import { setTimeZone } from './utils/date';

require('dotenv').config();

const bugsnagClient = bugsnag('5802c4a007b7d1992ca51b2d490daa91');
bugsnagClient.use(bugsnagReact, React);

// if (process.env.NODE_ENV !== 'production') {
//   const { whyDidYouUpdate } = require('why-did-you-update');
//   whyDidYouUpdate(React);
// }

// import './assets/css/style.css';

const initialState =
  window.__PRELOADED_STATE__ || JSON.parse(localStorage.getItem('authState'));
delete window.__PRELOADED_STATE__;

export const store = configureStore(initialState || {});

const history = syncHistoryWithStore(browserHistory, store);

history.listen(location => {
  const newUrl = location.pathname + location.search;

  if (!isGuiRoute(location.pathname)) {
    const { socket } = store.getState();
    if (socket.instances || socket.api || socket.current) {
      store.dispatch(disconnectSockets(socket.instances, socket.api));
    }
  }

  if (window.ga) {
    window.ga('set', 'page', newUrl);
    window.ga('send', 'pageview');
  }

  trackProgkids(newUrl);
});

function onAppInit({ location }) {
  const state = store.getState();
  const user = state.auth.user;

  const url = location.pathname;
  if (user && !user.confirmed && !url.startsWith('/i/confirm')) {
    // store.dispatch(
    //   addError(<TranslatedText id="auth.confirm.pleaseConfirm" />)
    // );
  }

  if (user) {
    trackYandexParams({ user_id: user._id });
    initCarrotQuest(user);
    setTimeZone(user.timezone);
  }

  //lowercase paths for better seo experience, only client side
  if (url !== url.toLowerCase()) {
    history.replace(url.toLowerCase() + location.search);
  }

  const urlWithQuery = url + location.search;
  trackProgkids(urlWithQuery);

  const initialUrl = localStorage.getItem('initialUrl');
  if (!initialUrl) {
    localStorage.setItem('initialUrl', urlWithQuery);
  }

  syncTranslationWithStore(store);
  store.dispatch(loadTranslations(translations));

  const lang = localStorage.getItem('lang') || 'ru';
  store.dispatch(setLocale(lang));
  document.documentElement.setAttribute('lang', lang);

  /*
  let lang = localStorage.getItem('lang');
  if (!lang) {
    lang = window.navigator.languages
      ? window.navigator.languages[0]
      : window.navigator.language || window.navigator.userLanguage;
    if (lang.indexOf('-') !== -1) lang = lang.split('-')[0];
    if (lang.indexOf('_') !== -1) lang = lang.split('_')[0];
  }
  store.dispatch(actionChangeLang(lang));
  */
}

function routeChange() {
  store.dispatch(actionRouteChange());
}
const ErrorBoundary = bugsnagClient.getPlugin('react');

const FullApp = (
  <HeadProvider>
    <Provider store={store} key="provider">
      <ErrorBoundary>
        <ConfigProvider locale={ruRU}>
          <App
            onInit={onAppInit}
            onRouteChange={routeChange}
            history={history}
          />
        </ConfigProvider>
      </ErrorBoundary>
    </Provider>
  </HeadProvider>
);

if (process.env.NODE_ENV === 'production') {
  ReactDOM.hydrate(FullApp, document.getElementById('root'));
} else {
  ReactDOM.render(FullApp, document.getElementById('root'));
}
